import React from "react";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";

// Tijdelijke interface totdat de types gegenereerd zijn
export interface HuidigeSituatieStelpost {
  omschrijving: string;
  belastingbox: number;
  bedragenPerAanvrager: HuidigeSituatieStelpostAanvrager[];
  inkomenMeegenomenTot: string;
}

export interface HuidigeSituatieStelpostAanvrager {
  naam: string;
  klantVolgnummer: number;
  bedrag: number | null;
  inkomenMeegenomenTot: string;
}

export interface InkomensStelpostenTableProps {
  data: HuidigeSituatieStelpost[];
  title: string;
}

export const InkomensStelpostenTable: React.FC<InkomensStelpostenTableProps> = ({
  data,
  title,
}: InkomensStelpostenTableProps) => {
  // Transform data to show each stelpost as a row with columns for each aanvrager
  const dataTransformed = data.map((stelpost) => {
    const row: any = {
      omschrijving: stelpost.omschrijving,
      inkomenMeegenomenTot: stelpost.inkomenMeegenomenTot,
    };

    // Add columns for each aanvrager
    stelpost.bedragenPerAanvrager.forEach((aanvrager) => {
      const columnKey = `aanvrager_${aanvrager.klantVolgnummer}`;
      row[columnKey] = aanvrager.bedrag;
      row[`${columnKey}_naam`] = aanvrager.naam;
    });

    return row;
  });

  if (dataTransformed.length === 0) {
    return null;
  }

  // Get unique aanvragers to create columns
  // istanbul ignore next
  const aanvragers =
    data.length > 0
      ? data[0].bedragenPerAanvrager.sort(
          (a, b) => a.klantVolgnummer - b.klantVolgnummer
        )
      : [];

  const columns: Column[] = [
    {
      header: title,
      accessor: "omschrijving",
    },
    ...aanvragers.map((aanvrager) => ({
      header: aanvrager.naam,
      accessor: `aanvrager_${aanvrager.klantVolgnummer}`,
      dataType: "currency" as const,
    })),
  ];

  return (
    <div className="mb-4">
      <Table
        columns={columns}
        data={dataTransformed}
        rotate={false}
        showHeader={true}
        id={`inkomens-stelposten-table-${title
          .toLowerCase()
          .replace(/\s+/g, "-")}`}
        regularStyles={dataTransformed?.length > 1}
      />
    </div>
  );
};
